import React, { useState, useRef, useEffect } from 'react';
import { Collapse, Button, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

export default function CollapsibleText({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [collapsedHeight, setCollapsedHeight] = useState(48); // ~2 lines
  const textRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => setExpanded((prev) => !prev);

  useEffect(() => {
    if (textRef.current) {
      const style = getComputedStyle(textRef.current);
      const lineHeight = parseFloat(style.lineHeight || '20');
      const maxCollapsedHeight = lineHeight * 2;

      if (textRef.current.scrollHeight > maxCollapsedHeight + 1) {
        setCollapsedHeight(maxCollapsedHeight);
        setIsOverflowing(true);
      } else {
        setCollapsedHeight(textRef.current.scrollHeight);
        setIsOverflowing(false);
      }
    }
  }, [text]);

  return (
    <Box>
      <Alert
        icon={false}
        severity="info"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch'
        }}
      >
        <Collapse in={expanded} collapsedSize={collapsedHeight}>
          <div
            ref={textRef}
            style={{
              overflow: 'hidden',
              display: expanded ? 'block' : '-webkit-box',
              WebkitLineClamp: expanded ? 'unset' : 2,
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'pre-line',
              textAlign: 'left'
            }}
          >
            {text}
          </div>
        </Collapse>

        {isOverflowing && (
          <Box
            style={{
              marginTop: 4,
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Button
              size="small"
              onClick={handleToggle}
              style={{
                textTransform: 'none',
                padding: '2px 6px',
                minWidth: 'auto'
              }}
            >
              {expanded ? 'Näytä vähemmän' : 'Näytä lisää'}
            </Button>
          </Box>
        )}
      </Alert>
    </Box>
  );
}
